import { getDefaultStatisticItem } from '../../utils/utils'

let previousActiveSide = null
let previousPlayTime = null

export default {
  statisticScheme: {
    possession: getDefaultStatisticItem('statistic.poss', { inPercents: true,  editable: false }),
    'CORNER_KICK': getDefaultStatisticItem('statistic.cornerKick'),
    'RED_CARD': getDefaultStatisticItem('statistic.redCard'),
    'YELLOW_CARD': getDefaultStatisticItem('statistic.yellowCard'),
    'FOUL': getDefaultStatisticItem()
  },
  statisticEvents: {
    'FOUL': 'FOUL',
    'CORNER_KICK': 'CORNER_KICK',
    'YELLOW_CARD': ['YELLOW_CARD', 'SECOND_YELLOW_CARD'],
    'RED_CARD': ['RED_CARD', 'SECOND_YELLOW_CARD']
  },
  statisticOrder: [
    'possession',
    'CORNER_KICK',
    'RED_CARD',
    'YELLOW_CARD'
  ],
  statisticFunction (event) {
    const {
      isTimerStoped,
      getActiveSide,
      getMatchPeriods,
      getCurrentPeriod
    } = this

    if (!getCurrentPeriod) return

    const { EventCode, Playtime, GamePeriod } = event
    const { overriddenType } = getMatchPeriods[getCurrentPeriod]

    if (!getActiveSide && !previousActiveSide) return

    if (['START_GAME_CLOCK', 'START_PERIOD'].includes(EventCode) || overriddenType === 'shootout') {
      previousPlayTime = Playtime

      return
    }

    if (EventCode === 'STOP_GAME_CLOCK') {
      this.updateStatistic({
        statisticType: 'defaultStatistic',
        property: 'possession',
        period: GamePeriod || getCurrentPeriod,
        team: previousActiveSide,
        type: 'increment',
        value: Playtime - previousPlayTime
      })
    }

    if (isTimerStoped) {
      previousPlayTime = Playtime

      return
    }

    if (previousActiveSide !== getActiveSide) {
      if (previousActiveSide) {
        this.updateStatistic({
          statisticType: 'defaultStatistic',
          property: 'possession',
          period: GamePeriod || getCurrentPeriod,
          team: previousActiveSide,
          type: 'increment',
          value: Playtime - previousPlayTime
        })
      }

      previousActiveSide = getActiveSide
      previousPlayTime = Playtime

      return
    }

    this.updateStatistic({
      statisticType: 'defaultStatistic',
      property: 'possession',
      period: GamePeriod || getCurrentPeriod,
      team: getActiveSide,
      type: 'increment',
      value: Playtime - previousPlayTime
    })

    previousPlayTime = Playtime
  },
  additionalStatisticBlocks: [
    {
      type: 'shootout',
      component: 'shootout-statistic'
    }
  ]
}
